/** URLs des photos (même origine : le cookie de session est envoyé avec `<img>`). */
export function photoThumbUrl(householdId: string, photoId: string) {
  return `/api/v1/households/${householdId}/photos/${photoId}/thumb`
}

export function photoUrl(householdId: string, photoId: string) {
  return `/api/v1/households/${householdId}/photos/${photoId}`
}
